"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OvernightLocationHeaderPanelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var OvernightLocationHeaderPanelWidget = /** @class */ (function (_super) {
    __extends(OvernightLocationHeaderPanelWidget, _super);
    function OvernightLocationHeaderPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicles = _this.props.interaction.vehicles;
        _this.vehiclesText = "";
        _this.vehicles.forEach(function (vehicle, index) {
            _this.vehiclesText += _this.capitalize(vehicle.make) + ", " + _this.capitalize(vehicle.model) + " (" + vehicle.registrationNumber + ")";
            if (index < _this.vehicles.length - 2 && _this.vehicles.length > 2) {
                _this.vehiclesText += ", ";
            }
            else if (index === _this.vehicles.length - 2) {
                _this.vehiclesText += " and ";
            }
            else if (index === _this.vehicles.length - 1) {
                _this.vehiclesText += ".";
            }
        });
        return _this;
    }
    OvernightLocationHeaderPanelWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "panel font-weight-light banner banner-info", children: (0, jsx_runtime_1.jsxs)("p", { children: ["Heads up - please ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "check overnight location" }), " for ", this.vehiclesText] }) }));
    };
    OvernightLocationHeaderPanelWidget.prototype.capitalize = function (text) {
        return text != null ?
            text.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase(); }).join(' ') : "";
    };
    return OvernightLocationHeaderPanelWidget;
}(plugin_journey_1.WidgetBase));
exports.OvernightLocationHeaderPanelWidget = OvernightLocationHeaderPanelWidget;
//# sourceMappingURL=OvernightLocationHeaderPanelWidget.js.map